import { IAddress, IUiMetaRecord } from '../generated';
import { L10nService } from '../l10n/l10n.service';

/**
 * Address.
 */
export class Address {
  constructor();
  constructor(source: Partial<IAddress>, l10n: L10nService);
  constructor(source?: Partial<IAddress>, l10n?: L10nService) {
    this._Init(source, l10n);
  }

  ID: number;
  StreetName: string;
  Address2: string;
  City: string;
  State: string;
  ZipCode: string;
  CountryCode: string;
  ReportedFromDate: string;
  ReportedToDate: string;
  IsCurrent: boolean;
  UiMeta?: IUiMetaRecord;

  /**
   * Initialize object with `source` data.
   *
   * @param source Source data object.
   * @param l10n L10n service instance.
   */
  private _Init(source?: Partial<IAddress>, l10n?: L10nService) {
    const defaultCountryCode = l10n ? l10n.currentCountry : undefined;

    if (!source) {
      this.CountryCode = defaultCountryCode;
      return;
    }

    this.ID = source.ID;
    this.StreetName = source.StreetName;
    this.Address2 = source.Address2;
    this.City = source.City;
    this.State = source.State;
    this.ZipCode = source.ZipCode;
    this.CountryCode = source.CountryCode || defaultCountryCode;
    this.ReportedFromDate = source.ReportedFromDate;
    this.ReportedToDate = source.ReportedToDate;
    this.IsCurrent = source.IsCurrent;
    this.UiMeta = source.UiMeta;
  }
}
